// extracted by mini-css-extract-plugin
module.exports = {"salta_odonto_center__redText":"SaltaOdontoCenter_salta_odonto_center__redText__2jza6","salta_odonto_center__image":"SaltaOdontoCenter_salta_odonto_center__image__18KTv"};